import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { CouponManageState } from "models/couponManage";

const initialState: CouponManageState = {
  loading: false,
  data: {},
  addCouponMessage: "",
  message: "",
  success: false,
  updateMessage: "",
  addCouponLoading: false,
  updateCouponMessage: "",
  updateCouponLoading: false,
  deleteLoading: false,
  deleteMessage: "",
  imgLoading: false,
  imgUrl: "",
};

const couponManageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    getCoupon(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getCouponSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getCouponFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    addCoupon(state, action: PayloadAction<ApiResponse>) {
      state.addCouponLoading = true;
      state.addCouponMessage = "";
    },
    addCouponSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addCouponLoading = false;
      state.addCouponMessage = action.payload.message;
      state.success = action.payload.success;
    },
    addCouponFailed(state, action: PayloadAction<ApiResponse>) {
      state.addCouponLoading = false;
      state.addCouponMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateCoupon(state, action: PayloadAction<ApiResponse>) {
      state.updateCouponLoading = true;
      state.updateCouponMessage = "";
    },
    updateCouponSuccess(state, action: PayloadAction<ApiResponse>) {
      state.updateCouponLoading = false;
      state.updateCouponMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateCouponFailed(state, action: PayloadAction<ApiResponse>) {
      state.updateCouponLoading = false;
      state.updateCouponMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteCoupon(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = true;
      state.deleteMessage = "";
    },
    deleteCouponSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteCouponFailed(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    getImageUrl(state, action: PayloadAction<ApiResponse>) {
      state.imgLoading = true;
      state.imgUrl = "";
    },
    getImageUrlSuccess(state, action: PayloadAction<ApiResponse>) {
      state.imgLoading = false;
      state.imgUrl = action.payload.photoURL;
    },
    getImageUrlFailed(state, action: PayloadAction<ApiResponse>) {
      state.imgLoading = false;
      state.imgUrl = "";
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.addCouponLoading = false;
      state.addCouponMessage = "";
      state.updateMessage = "";
      state.deleteMessage = "";
      state.updateCouponMessage = "";
      state.updateCouponLoading = false;
      state.deleteMessage = "";
      state.deleteLoading = false;
      state.imgUrl = "";
      state.imgLoading = false;
    },
  },
});

//Actions
export const couponManageActions = couponManageSlice.actions;

//Selectors
export const getCouponData = (state: RootState) => state.couponManage.data;
export const getCouponDataLoad = (state: RootState) =>
  state.couponManage.loading;
export const addCouponIsLoading = (state: RootState) =>
  state.couponManage.addCouponLoading;
export const addCouponIsMessage = (state: RootState) =>
  state.couponManage.addCouponMessage;
export const updateCouponnMessage = (state: RootState) =>
  state.couponManage.updateCouponMessage;
export const updateCouponLoading = (state: RootState) =>
  state.couponManage.updateCouponLoading;
export const deleteCouponLoad = (state: RootState) =>
  state.couponManage.deleteLoading;
export const deleteCouponMsg = (state: RootState) =>
  state.couponManage.deleteMessage;
export const couponImgLoading = (state: RootState) =>
  state.couponManage.imgLoading;
export const couponImgUrlBack = (state: RootState) => state.couponManage.imgUrl;

//Reducers
const couponManageReducer = couponManageSlice.reducer;
export default couponManageReducer;
